import React, {Component} from 'react';
import _ from 'lodash';
import {
    Button,
    Label,
    Input,
    FormGroup,
    Form,
    Col,
    Popover,
    PopoverBody
} from 'reactstrap';
import PropTypes from 'prop-types';
import './RegisterOrgByAnchor.css';
import FormWrapper from './../../commonComponents/formWrapper/FormWrapper.container';
import {Utils} from './../../../utils/utils';
import {sharedLabelsPath} from "../../../reducers/common/localization";
import { EMPLOYEES_COUNT_VALUES } from './../../../constants/constants';
import {COMPANY} from "../../../reducers/organization/organizations";
import RegisterOrgByAnchorModal from "../registerOrgByAnchorModal/RegisterOrgByAnchorModal.container";
import IconContainer from "../../commonComponents/iconContainer/IconContainer";
import BackButtonComponent from "../../commonComponents/backButtonComponent/BackButtonComponent";
import Select from "../../commonComponents/customSelect/CustomSelect.container";
import DomainInput from "../../commonComponents/domainInput/DomainInput";
import LicenseAgreementModal from '../../commonComponents/licenseAgreement/LicenseAgreementModal.container';

const requiredSelectFields = ['orgCountry'];

class RegisterOrgByAnchor extends Component {
    constructor(props) {
        super(props);
        this.state = {
            orgName: '',
            orgDomain: '',
            orgVatNumber: '',
            companyCode: '',
            orgContinent: this.props.continentCode,
            orgEmployeeCount: 'UNKNOWN',
            orgCountry: '',
            orgCity: '',
            orgPostal: '',
            orgStreet: '',
            orgStreetNumber: '',
            orgBusNumber: '',
            anchorFirstName: '',
            anchorLastName: '',
            anchorEmail: '',
            financialData: '',
            popoverOpen: null,
            success: false,
            requiredFieldError: null,
            agreeWithLicense: false
        };
        this.resetData = this.resetData.bind(this);
    }

    componentWillReceiveProps(nextProps) {
        if (this.state.orgContinent !== nextProps.continentCode) {
            this.setState({orgContinent: nextProps.continentCode})
        }
        if(nextProps.success && !this.props.success) {
            this.setState({ success: true });
        }
    }

    componentWillUnmount() {
        this.props.onContinentSet('');
    }

    render() {
        if (this.state.success) {
            return (
                <div>
                    <BackButtonComponent path='/login' label={_.get(this.props.translation, 'register_org.back_button')}/>
                    <h6 className="text-center success-message-header">
                        {_.get(this.props.translation, 'register_org.success_message')}
                    </h6>
                    <h6 className="text-center success-message-header">
                        {_.get(this.props.translation, 'register_applicant.success_message')}
                    </h6>
                </div>
            )
        }
        return (
            <div className="register-anchor-org-by-anchor-container">
                <FormWrapper
                    successMessage={_.get(this.props.translation, 'register_org.success_message')}>
                    <BackButtonComponent path='/login' label={_.get(this.props.translation, 'register_org.back_button')}/>
                    <div className="register-anchor-org-form">
                        <h4 className="text-center">{_.get(this.props.translation, 'register_org.company_registration_label')}</h4>
                        <Form onSubmit={this.onSubmit}>
                            <h5 className="register-anchor-org-subtitle olive-green">{_.get(this.props.translation, sharedLabelsPath.org_label)}</h5>
                            {this.renderOrganizationDataFormGroups()}
                            <h6>{_.get(this.props.translation, 'orgs.address_label')}</h6>
                            {this.renderOrganizationAddressFormGroup()}
                            <h5 className="register-anchor-org-subtitle olive-green">{_.get(this.props.translation, 'orgs.anchor_label')}</h5>
                            {this.renderAnchorFormGroups()}
                            <div className="buttons-group">
                                <div className="register-anchor-org-license-agreement-container">
                                    <Label className='checkbox-label'>
                                        <Input
                                            type="checkbox"
                                            checked={this.state.agreeWithLicense}
                                            onChange={this.handleChangeAgreement}
                                        />
                                        {_.get(this.props.translation, "license_agreement.agree_label")}
                                        <a href="" className="register-anchor-org-license-agreement-link" onClick={this.handleClickLicenseAgreement}>
                                            {_.get(this.props.translation, "license_agreement.agree_link")}
                                        </a>
                                    </Label>
                                </div>
                                <Button type="submit" className="olive-green-btn"
                                        disabled={!this.state.agreeWithLicense}>{_.get(this.props.translation, 'register_org.register_button')}</Button>
                            </div>
                            <RegisterOrgByAnchorModal orgName={this.state.orgName} orgCountryCode={this.state.orgCountry} onProceed={this.handleProceed}/>
                        </Form>
                    </div>
                </FormWrapper>
                <LicenseAgreementModal onAgree={this.handleAgree}/>
            </div>
        );
    }

    renderOrganizationDataFormGroups = () => {
        let paramsList = [
            {
                value: "orgName",
                title: _.get(this.props.translation, 'orgs.name_label') + "*",
                isRequired: true,
                placeholder: _.get(this.props.translation, 'orgs.name_label')
            },
            {
                value: "orgDomain",
                title: _.get(this.props.translation, sharedLabelsPath.domain_label) + "*",
                isRequired: true,
                placeholder: _.get(this.props.translation, sharedLabelsPath.domain_label)
            },
            {
                value: "orgVatNumber",
                title: _.get(this.props.translation, 'orgs.vat_number_label'),
                isRequired: false,
                placeholder: _.get(this.props.translation, 'orgs.vat_number_label')
            },
            {
                value: "companyCode",
                title: _.get(this.props.translation, 'orgs.company_code_label'),
                isRequired: false,
                placeholder: _.get(this.props.translation, 'orgs.company_code_label')
            },
            {
                value: 'orgEmployeeCount',
                title: _.get(this.props.translation, sharedLabelsPath.employee_count_label),
                type: 'select',
                content: Utils.getOptions(_.map(EMPLOYEES_COUNT_VALUES, value => ({
                    code: value.code,
                    name: _.get(this.props.translation, value.name) || value.name
                }))),
                onChange: this.handleChangeSelect('orgEmployeeCount')
            },
            {
                value: 'financialData',
                title: _.get(this.props.translation, 'orgs.financial_data_label') + '*',
                type: 'textarea',
                placeholder: _.get(this.props.translation, 'orgs.financial_data_placeholder'),
                isRequired: true
            }
        ];

        return [..._.map(paramsList, this.getFormGroup)];
    };

    renderOrganizationAddressFormGroup = () => {
        let paramsList = [
            {
                value: "orgContinent",
                title: _.get(this.props.translation, sharedLabelsPath.continent_filter_label) + '*',
                onChange: this.handleChangeContinent,
                type: 'select',
                content: Utils.getLocationOptions(
                    this.props.continents,
                    _.get(this.props.translation, sharedLabelsPath.continents)
                ),
                placeholder: _.get(this.props.translation, sharedLabelsPath.continent_input_placeholder),
                isDisabled: !this.props.continents
            },
            {
                value: "orgCountry",
                title: _.get(this.props.translation, sharedLabelsPath.country_label) + '*',
                onChange: this.handleChangeSelect('orgCountry'),
                type: 'select',
                content: Utils.getLocationOptions(
                    this.props.countries,
                    _.get(this.props.translation, sharedLabelsPath.countries)
                ),
                placeholder:_.get(this.props.translation, sharedLabelsPath.country_input_placeholder),
                isDisabled: !this.props.countries
            },
            {
                value: "orgCity",
                title: _.get(this.props.translation, 'orgs.city_label') + '*',
                isRequired: true,
                placeholder: _.get(this.props.translation, 'orgs.city_label')
            },
            {
                value: "orgPostal",
                title: _.get(this.props.translation, 'orgs.postal_label') + '*',
                isRequired: true,
                placeholder: _.get(this.props.translation, 'orgs.postal_label')
            },
            {
                value: "orgStreet",
                title: _.get(this.props.translation, 'orgs.street_label') + '*',
                isRequired: true,
                placeholder: _.get(this.props.translation, 'orgs.street_label')
            }
        ];

        return [..._.map(paramsList, this.getFormGroup)];
    };

    renderAnchorFormGroups = () => {
        let paramsList = [
            {
                value: "anchorEmail",
                title: _.get(this.props.translation, sharedLabelsPath.email_label) + "*",
                type: "email",
                isRequired: true,
                placeholder: _.get(this.props.translation, sharedLabelsPath.email_label)
            },
            {
                value: "anchorFirstName",
                title: _.get(this.props.translation, sharedLabelsPath.first_name_label) + "*",
                isRequired: true,
                placeholder: _.get(this.props.translation, sharedLabelsPath.first_name_label)
            },
            {
                value: "anchorLastName",
                title: _.get(this.props.translation, sharedLabelsPath.last_name_label) + "*",
                isRequired: true,
                placeholder: _.get(this.props.translation, sharedLabelsPath.last_name_label)
            }
        ];

        return [..._.map(paramsList, this.getFormGroup)];
    };

    getFormGroup = (params) => {
        if (params.type === 'select') {
            return this.getSelectFormGroup(params);
        }
        if (params.value === 'orgDomain') {
            return this.getOrganizationDomainFormGroup(params);
        }
        if (!params || typeof (params) !== 'object') {
            return;
        }
        let id = _.kebabCase(params.value);
        return (
            <FormGroup row key={params.title}>
                {this.renderPopover(params)}
                <Label for={id} sm={3}>{params.title}</Label>
                <Col sm={9}>
                    <Input type={params.type || 'text'} id={id}
                           value={this.state[params.value]}
                           onChange={params.onChange || this.handleChange(params.value)}
                           placeholder={params.placeholder}
                           disabled={params.isDisabled}
                           required={params.isRequired}
                    >
                        {params.content}
                    </Input>
                </Col>
            </FormGroup>
        );
    };

    getOrganizationDomainFormGroup = (params) => {
        let id = _.kebabCase(params.value);
        return (
            <FormGroup row key={params.title}>
                {this.renderPopover(params)}
                <Label for={id} sm={3}>{params.title}</Label>
                <Col sm={9}>
                    <DomainInput id={id}
                                 value={this.state[params.value]}
                                 onChange={this.handleChangeDomainInput}
                                 placeholder={params.placeholder || params.title}
                                 disabled={params.isDisabled}
                                 required={params.isRequired}/>
                </Col>
            </FormGroup>
        );
    };

    getSelectFormGroup = (params) => {
        if (!params || typeof (params) !== 'object') {
            return;
        }
        let id = _.kebabCase(params.value);
        return (
            <FormGroup row key={params.title}>
                <Label for={id} sm={3}>{params.title + (params.isRequired ? '*' : '')}</Label>
                <Col sm={9}>
                    <Select id={id}
                            selectedOption={_.find(params.content, option => option.value === this.state[params.value])}
                            options={params.content}
                            onSelect={params.onChange}
                            placeholder={params.placeholder}
                            disabled={params.isDisabled}
                            requiredFieldError={this.state.requiredFieldError === params.value}
                    />
                </Col>
            </FormGroup>
        );
    };

    renderPopover = (params) => {
        let hintText = '';
        let id = 'register-org-by-anchor-';

        switch (params.value) {
            case 'orgDomain':
                id += 'domain-hint-container';
                hintText = _.get(this.props.translation, 'register_org.domain_hint');
                break;
            case 'companyCode':
                id += 'company-code-hint-container';
                hintText = _.get(this.props.translation, 'register_org.company_code_hint');
                break;
            case 'financialData':
                id += 'financial-data-container';
                hintText = [
                    <div key='part_1'>{_.get(this.props.translation, 'register_org.financial_data_hint_part_1')}</div>,
                    <div key='part_2'>{_.get(this.props.translation, 'register_org.financial_data_hint_part_2')}</div>,
                    <div key='part_3'>{_.get(this.props.translation, 'register_org.financial_data_hint_part_3')}</div>
                ];
                break;
            default:
                return;
        }

        return (
            <div className="register-org-by-anchor-domain-hint-container">
                <span id={id} className='register-org-by-anchor-icon-container' onClick={this.togglePopover}>
                    <IconContainer icon='question_mark' title={_.get(this.props.translation, sharedLabelsPath.about_label)}/>
                </span>
                <Popover placement="bottom" isOpen={this.state.popoverOpen === params.value} target={id}
                         toggle={this.togglePopover(params.value)}>
                    <PopoverBody>
                        {hintText}
                    </PopoverBody>
                </Popover>
            </div>
        );
    };

    handleAgree = () => {
        this.setState({agreeWithLicense: true});
    };

    handleChangeAgreement = () => {
        this.setState({agreeWithLicense: !this.state.agreeWithLicense});
    };

    handleClickLicenseAgreement = (e) => {
        e.preventDefault();
        console.log('click');

        this.props.onShowLicenseAgreement();
    };

    togglePopover = (type) => () => {
        if (this.state.popoverOpen === type) {
            this.setState({popoverOpen: null});
        } else {
            this.setState({popoverOpen: type});
        }
    };

    handleChangeSelect = (fieldKey) => (selectedOption) => {
        this.setState({[fieldKey]: selectedOption.value});
    };

    handleChange = (fieldKey) => (e) => {
        this.setState({[fieldKey]: e.target.value});
    };

    handleChangeDomainInput = (data) => {
        this.setState({orgDomain: data});
    };

    toggleCheckbox = (fieldKey) => () => {
        this.setState({[fieldKey]: !this.state[fieldKey]})
    };

    handleChangeContinent = (selectedOption) => {
        this.props.onContinentSet(selectedOption.value);
        this.setState({ orgCountry: '' });
    };

    onSubmit = (e) => {
        e.preventDefault();

        if (this.checkRequiredSelectFields()) {
            return;
        }

        this.props.onOpenModal(this.state.orgCountry, COMPANY);
    };

    handleProceed = () => {
        let data = {
            type: COMPANY,
            name: this.state.orgName,
            domain: this.state.orgDomain,
            address: {
                countryCode: this.state.orgCountry,
                city: this.state.orgCity,
                postal: this.state.orgPostal,
                street: this.state.orgStreet
            },
            vatNumber: this.state.orgVatNumber,
            companyCode: this.state.companyCode,
            anchor: {
                email: this.state.anchorEmail,
                identityAlias: {
                    firstName: this.state.anchorFirstName,
                    lastName: this.state.anchorLastName,
                    countryCode: this.state.orgCountry
                }
            },
            hasIVs: false,
            verifiesIdentities: false,
            providesMoocCertificates: false,
            employeeCount: this.state.orgEmployeeCount,
            financialData: this.state.financialData,
            validated: false
        };

        this.props.onRegister(data);
    };

    resetData() {
        this.setState({
            orgName: '',
            orgDomain: '',
            orgVatNumber: '',
            companyCode: '',
            orgContinent: this.props.continentCode,
            orgEmployeeCount: 'UNKNOWN',
            orgCountry: '',
            orgCity: '',
            orgPostal: '',
            orgStreet: '',
            orgStreetNumber: '',
            orgBusNumber: '',
            anchorFirstName: '',
            anchorLastName: '',
            anchorEmail: '',
            popoverOpen: null
        });

        this.props.onContinentSet('');
    }

    checkRequiredSelectFields = () => {
        let error = null;
        _.map(requiredSelectFields, field => {
            if (!this.state[field] && !error) {
                error = field;
            }
        });
        this.setState({requiredFieldError: error});
        return error;
    }
}

RegisterOrgByAnchor.propTypes = {
    continentCode: PropTypes.string,
    continents: PropTypes.array,
    countries: PropTypes.array,
    lastUsedContinent: PropTypes.string,
    success: PropTypes.bool,
    translation: PropTypes.object.isRequired,
    onRegister: PropTypes.func.isRequired,
    onContinentSet: PropTypes.func.isRequired,
    onOpenModal: PropTypes.func.isRequired,
    onShowLicenseAgreement: PropTypes.func.isRequired
};

export default RegisterOrgByAnchor;



// WEBPACK FOOTER //
// ./src/components/organizationManagement/registerOrgByAnchor/RegisterOrgByAnchor.js